import React from 'react';
import { Line } from 'react-chartjs-2';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const ResultChart = ({ inputs, status }: any) => {
  const { labels, data: inputData } = inputs;
  const theme: any = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));

  const data = {
    labels,
    datasets: [
      {
        label: '# of Votes',
        data: inputData,
        fill: true,
        backgroundColor: theme.palette.results[status].light,
        borderColor: theme.palette.results[status].dark,
        borderWidth: 3,
        borderJoinStyle: 'butt',
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    animation: {
      duration: 0,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          maxTicksLimit: 5,
          padding: isSmallDevice ? 0 : theme.spacing(2),
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          maxTicksLimit: isSmallDevice ? 3 : 6,
          padding: isSmallDevice ? 0 : theme.spacing(2),
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};
